
import {computed, defineComponent, ref, watch} from "vue";
import SvgIcon from "@/components/common/SvgIcon.vue";
import Tabs from "@/components/Tabs.vue";
import store from "@/store";
import About from "@/components/About.vue";
import Login from "@/views/Login.vue";
import router from "@/router";
import i18n from "@/locales";
const vicBg = require("@/assets/image/bg-vic2.png");
const bvicBg = require("@/assets/image/bg-bvic2.png");
const tvicBg = require("@/assets/image/bg-tvic2.png");

const headers = ['VIC', "Beauty VIC", "Tourist VIC"];

export default defineComponent({
  components: {Login, About, Tabs, SvgIcon},
  displayName: "Home",
  setup() {
    const bannerRef = ref<HTMLElement|null>(null);
    const loginRef = ref<typeof Login|null>(null);

    const isLogin = computed(() => store.state.isLogin);

    // 0: VIC, 1: BVIC, 2: TVIC
    const vicLogoName = ref('logo-vic');
    const onVicTypeChange = (type: number) => {
      if (type === 1) {
        vicLogoName.value = 'logo-bvic';
      } else if (type === 2) {
        vicLogoName.value = 'logo-tvic';
      } else {
        vicLogoName.value = 'logo-vic';
      }
    }

    const storeType = computed(() => store.state.selectedType);
    const tabsSelected = ref(storeType.value);

    const onTabUpdated = (type: number) => {
      tabsSelected.value = type;
      store.commit('onTypeChange', type);
      onVicTypeChange(type);
    }
    watch(storeType, (type: number) => {
      if (bannerRef.value) {
        bannerRef.value.scrollIntoView({
          behavior: "smooth",
        });
      }
      tabsSelected.value = type;
      onVicTypeChange(type);
    });
    onVicTypeChange(tabsSelected.value);

    const onLoginClick = () => {
      if (isLogin.value) {
        router.push({
          name: 'Member',
          params: {
            lang: i18n.global.locale
          }
        });
      } else {
        loginRef.value?.$el?.scrollIntoView({
          behavior: "smooth"
        });
      }
    }

    return {
      bannerRef,
      loginRef,
      isLogin,
      vicBg,
      bvicBg,
      tvicBg,
      vicLogoName,
      onVicTypeChange,
      headers,
      tabsSelected,
      onTabUpdated,
      onLoginClick
    }
  }
});
